import React from 'react'
import styled from 'styled-components'
import Plus2 from '../../../icons/Plus2'

const AnchorButton = React.forwardRef(({ text, action, ...props }, ref) => {
  return (
    <StyledButton onClick={action} ref={ref} {...props}>

          <Text>
            {text}
          </Text>
      
    </StyledButton>
  )
})

export default AnchorButton

const StyledButton = styled.button`
 
  color: #145BFF;
  background-color: #E5EDFF;
  border: 2px solid #C2D4FF;
  font-weight: var(--fontWeight-veryBold);
  border-radius: 12px;
  padding: 1rem;
  transition: 0.2s;
  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
    box-shadow: 0px 0px 10px var(--color-shadow);
    
  }
  @media (min-width: 50px) {
    font-size: var(--font-text);
  }
  @media (min-width: 600px) {
    font-size: var(--font-text);
  }
  @media (min-width: 900px) {
    font-size: var(--font-base);
  }
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 0.5fr;
  height: 100%;
  padding: var(--spacing-smallPlus);
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const Text = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: var(--spacing-small);
`
